import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import CheckBoxFactory from '@/Factories/ControlFactories/CheckBoxFactory';
import TwoFactorAuthQRCheckBoxViewModel from '@/Components/TwoFaktorAuth/TwoFactorEnable/TwoFactorAuthQRCheckBoxViewModel';
import TwoFactorAuthQRCheckBox from '@/Components/TwoFaktorAuth/TwoFactorEnable/TwoFactorAuthQRCheckBox';

/**
 * Bildet die Komponente ab, welche bspw. innerhalb der Useranlage zu finden ist
 */

export default class TwoFactorAuthQRCheckBoxFactory extends CheckBoxFactory {
    private TwoFactorAuthQRCheckBoxViewModel = ComponentManager.getViewModel<typeof TwoFactorAuthQRCheckBoxViewModel>('TwoFactorAuthQRCheckBoxViewModel');
    private TwoFactorAuthQRCheckBox = ComponentManager.getControl<typeof TwoFactorAuthQRCheckBox>('TwoFactorAuthQRCheckBox');

    public viewModel: TwoFactorAuthQRCheckBoxViewModel;

    public constructor(params) {
        super(params);
    }

    protected createViewModelParamater(): any {
        let params = super.createViewModelParamater();
        params.context = this.context,
        params.label = new LabelViewModel({
                isVisible: !!this.detailViewItem.unitErgName,
                ergName: this.detailViewItem.unitErgName
        })

        return params;
    }

    protected createViewModel(parameter: any): TwoFactorAuthQRCheckBoxViewModel {
        return new this.TwoFactorAuthQRCheckBoxViewModel(parameter);
    }

    protected createControl(viewModel: TwoFactorAuthQRCheckBoxViewModel): TwoFactorAuthQRCheckBox {
        return new this.TwoFactorAuthQRCheckBox(this.viewModel);
    }
}

ComponentManager.setFactory('TwoFactorAuthQRCheckBox', TwoFactorAuthQRCheckBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');